import { createContext, useContext, useMemo, type ReactNode } from 'react';

export type SelectPanelContextValue = {
  disabled: boolean;
  isLoading: boolean;
};

const defaultSelectPanel: SelectPanelContextValue = {
  disabled: false,
  isLoading: false,
};

export const SelectPanelContext = createContext<SelectPanelContextValue>(defaultSelectPanel);

export function SelectPanelProvider({
  disabled = false,
  isLoading = false,
  children,
}: {
  disabled?: boolean;
  isLoading?: boolean;
  children: ReactNode;
}) {
  const value = useMemo((): SelectPanelContextValue => ({ disabled, isLoading }), [disabled, isLoading]);
  return <SelectPanelContext.Provider value={value}>{children}</SelectPanelContext.Provider>;
}

/** Panel state for option rows inside the dropdown list (disabled / loading). */
export function useSelectPanel(): SelectPanelContextValue {
  return useContext(SelectPanelContext);
}
